module.exports = __webpack_public_path__ + "static/media/WebSurfer-snapshot-2.fb5deff2.png";


//////////////////
// WEBPACK FOOTER
// ./images/DashMobile/WebSurfer-snapshot-2.png
// module id = 444
// module chunks = 0